import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Icon from './Icon';
import { services } from '../mock/mock';

export default function ServicesGrid({ detailed = false }) {
  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {services.map((s) => (
        <div key={s.slug} className="reveal glass glass-hover rounded-2xl p-7 group relative overflow-hidden">
          <div className="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-[#2563eb]/10 blur-2xl group-hover:bg-[#2563eb]/20 transition-colors" />
          <div className="relative">
            <div className="w-12 h-12 rounded-xl bg-[#2563eb]/12 grid place-items-center text-[#2563eb] mb-5 group-hover:scale-110 transition-transform">
              <Icon name={s.icon} size={24} />
            </div>
            <h3 className="font-display text-xl font-semibold text-slate-900 mb-2">{s.title}</h3>
            <p className="text-sm text-slate-500 leading-relaxed">{detailed ? s.long : s.short}</p>
            {detailed && (
              <ul className="mt-4 space-y-1.5">
                {s.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm text-slate-600">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#2563eb]" /> {f}
                  </li>
                ))}
              </ul>
            )}
            {!detailed && (
              <Link to="/solutions" className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#2563eb] group-hover:gap-2.5 transition-all">
                Learn more <ArrowRight size={15} />
              </Link>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
